import AjaxService from "services/base/Ajax.service";

class MetaService extends AjaxService {
  async getFooterInfo() {
    return this.get("/meta/footerInfo");
  }
}

export default new MetaService();
